import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Grid } from 'react-bootstrap'
import NavBar from '../components/NavBar'

class IndexPage extends Component {
  render() {
    return (
      <div>
        <NavBar returnUrl={this.props.location.query.returnUrl} />
        <Grid>
          {this.props.children}
        </Grid>
      </div>
    )
  }
}

IndexPage.propTypes = {
  children: PropTypes.node,
}

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/IndexPage.js